import React, { useEffect, useState } from "react";
import {
  createStyles,
  Theme,
  makeStyles,
  Container,
  Grid,
  Typography,
  Paper,
} from "@material-ui/core";
import { GET_HISTORIES } from "../../../../quries/history";
import { useQuery } from "@apollo/client";
import HistoryDetail from "./HistoryDetail";
import {
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  TimelineOppositeContent,
  TimelineSeparator,
} from "@material-ui/lab";
import CustomTimeLine from "./CustomTimeLine";

interface AboutHistoryProps {
  history: History;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paper: {
      // padding: "6px 16px",
      paddingLeft: 32,
    },
  })
);

function AboutHistory() {
  const classes = useStyles();
  const [historyArr, setHistoryArr] = useState<any>(null);
  const { data, loading, error } = useQuery(GET_HISTORIES, {
    variables: {
      sort: "year:DESC",
    },
  });

  useEffect(() => {
    if (data && data.histories) {
      if (data.histories.length > 0) {
        setHistoryArr(data.histories);
      }
      return () => {
        setHistoryArr(null);
      };
    }
  }, [data]);

  if (loading) return null;
  if (data === undefined) return null;
  if (error || !data.histories) {
    console.log(error);
  }

  return (
    <Container
      maxWidth={"xl"}
      disableGutters={true}
      // style={{ paddingTop: "6rem" }}
    >
      <Grid
        item
        xs={12}
        component={"h2"}
        style={{
          fontSize: 56,
          fontFamily: "Noto Sans KR",
          fontWeight: 900,
          letterSpacing: -4,
          textAlign: "center",
          // paddingRight: "4rem",
        }}
      >
        문화제 진행사업
      </Grid>
      <Grid
        item
        xs={12}
        style={{
          // paddingLeft: "4rem",
          // paddingRight: "4rem",
          paddingTop: "2rem",
        }}
      >
        <CustomTimeLine historyArr={historyArr} />
      </Grid>
    </Container>
  );
}

export default AboutHistory;
